import PartnerDetailsResponse from "../../../api/raily/partner/details/partner-details.response";
import PartnerDetails from "./partner-details";

const create = (response: PartnerDetailsResponse): PartnerDetails => {
  return {
    name: response.data.name,
    notes: response.data.notes,
  };
};

const partnerDetailsFactory = {
  create,
};

export default partnerDetailsFactory;
